/**
 * @desc pageList
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierSnBatch.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSnBatch/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
